import React from 'react';
import { motion } from 'framer-motion';

export const TREE_SVG_URL =
  'https://cdn.prod.website-files.com/67a5364f6209b8a412187df5/67aa7f960e2601bd6231c3e9_39e08419042369cead141d09b28a0674_footer_tree.svg';

export const TreeWatermark: React.FC<{
  className?: string;
  style?: React.CSSProperties;
  color?: string;
  animate?: boolean;
}> = ({ className = '', style = {}, color = 'var(--color-primary-600)', animate = true }) => {
  const inner = (
    <div
      className={`pointer-events-none ${className}`}
      style={{
        WebkitMaskImage: `url(${TREE_SVG_URL})`,
        maskImage: `url(${TREE_SVG_URL})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        backgroundColor: color,
        ...style,
      }}
    />
  );
  if (!animate) return inner;
  return (
    <motion.div
      className="pointer-events-none"
      style={{ position: 'absolute', inset: 0 }}
      animate={{ scale: [1, 1.02, 1] }}
      transition={{ duration: 30, repeat: Infinity, ease: 'easeInOut' }}
    >
      {inner}
    </motion.div>
  );
};
